<template>
    <form data-vv-scope="step-3">
        <div class="vx-row" > <!--v-show="payrollType.createPayrollTypeId == 2 || payrollType.createPayrollTypeId == 3"> -->
          <vs-alert class="mt-5" icon-pack="feather" icon="icon-info" color="warning">
                <span>Quick reminder to thoroughly review all data before uploading (Earnings, Deductions & Loans), as the process is irreversible. If anything is missed, go ahead and upload only the remaining ones separately.</span>
                <!-- <span  class="hover:underline" style= "cursor:pointer;color=primary" @click="onCloseNow()">Close Now</span> -->
                    <!-- <vs-button class="button" type="line" @click="onCloseNow()"><strong>Close Now</strong></vs-button></span> -->
            </vs-alert>
            <div class="vx-col sm:w-1/6  w-full md:mt-8" >
                <div class="demo-alignment">
                <span class="mr-4">Upload Template:</span>
                <div class="flex">
                    <vs-switch v-model="uploadSwitch">Upload Template</vs-switch>
                </div>
                </div>
            </div>
         </div>

        <!-- UPLOAD OFF -->
        <div class="vx-row" v-show="!uploadSwitch">
            <div class="w-full mt-5">
            <vx-card class="no-scroll-content">
                <vs-button color="success" type="filled" icon-pack="feather" icon="icon-calendar">Generate TimeLogs</vs-button>
                <vs-table class="no-scroll-content" stripe pagination :max-items="10" search :data="tableData"   >

                    <template slot="thead">
                        <vs-th sort-key="createdOn">Date Applied</vs-th>
                        <vs-th sort-key="leaveTypeId">Leave Type</vs-th>
                        <vs-th sort-key="fromDate">From Date</vs-th>
                        <vs-th>To Date</vs-th>
                        <vs-th>No Of Days</vs-th>
                        <vs-th>Reason</vs-th>
                        <vs-th>Approvers</vs-th>
                        <vs-th><vs-icon  color="primary" icon-pack="feather" icon="icon-paperclip"  /></vs-th>
                        <vs-th>Status</vs-th>
                        <vs-th>Remarks</vs-th>
                        <vs-th>Actions</vs-th>
                    </template>
                </vs-table>
            </vx-card>
            </div>
        </div>

        <!-- END UPLOAD OFF -->

        <!-- UPLOAD ON -->
        <div class="vx-row" v-show="uploadSwitch">
            <div class="w-full mt-5">
                    <div class="mb-8">
                        <import-excel :onSuccess="loadDataInTable" />
                    </div>
                    <vx-card v-if="tableData.length && header.length">
                        <vs-table stripe pagination :max-items="10" search :data="tableData">
                            <template slot="header">
                            <h4>{{ sheetName }}</h4>
                            </template>

                            <template slot="thead">
                            <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
                            </template>

                            <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="col" v-for="(col, indexcol) in data[indextr]" :key="indexcol + col">
                                {{ col }}
                                </vs-td>
                            </vs-tr>
                            </template>
                        </vs-table>
                    <!-- <div class="vx-row">
                        <vs-row>
                        <vs-col class="mt-5" vs-offset="10" vs-tooltip="'col - 1'" vs-type="flex" vs-justify="center" vs-align="right" vs-w="2"> -->
                        <div class="flex justify-between flex-wrap mt-5">
                            <span/>
                            <vs-button @click="uploadData()" color="success" type="filled" icon-pack="feather" icon="icon-upload"> Upload</vs-button>
                        </div>
                        <!-- </vs-col>
                        </vs-row>
                    </div>-->
                    </vx-card>

                </div>

        </div>

    <!-- END UPLOAD ON -->
    </form>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import ImportExcel from '@/components/excel/ImportExcel.vue'

export default {
    props: {
        createPayroll: {
            type: Object,
            required: false
        },
    },
    data() {
        return {
            uploadSwitch    : true,
            isAppend        : false,
            whatToUpload    : null,

            tableData               : [],
            header                  : [],
            sheetName               : '',


        }
    },
    created() {
    },

    computed: {
        getSelectedEmployees() {
            return this.$store.state.selectedEmployees
        },
        getTemplateName() {
          return this.$store.state.lookup.templateName
        },

    },
    methods: {
        uploadData() {
          this.$vs.loading()
            const data = {
                  data: this.tableData,
                  createPayrollId: this.createPayroll.createPayrollId,
                  userId: this.$store.state.AppActiveUser.uid
                }
                // console.log(data)
            switch(this.sheetName) {
              case "Log Hours" :
                this.$store.dispatch('payroll/AddUploadedLogHours', data)
                .then((res) =>{
                            this.$vs.loading.close()
                            this.isUploaded = true
                            this.$alert(res.data.data.length + ' record(s) uploaded', 'Uploaded Successfully', 'success')
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$alert(error.message, 'Upload Failed', 'error')
                    })
                  break;
              case "Overtime" :
                this.$store.dispatch('payroll/AddUploadedOvertimeHours', data)
                .then((res) =>{
                            this.$vs.loading.close()
                            this.isUploaded = true
                            this.$alert(res.data.data.length + ' record(s) uploaded', 'Uploaded Successfully', 'success')
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$alert(error.message, 'Upload Failed', 'error')
                    })
                  break;
              case "Earnings" :
                this.$store.dispatch('payroll/AddUploadedEarnings', data)
                .then((res) =>{
                            this.$vs.loading.close()
                            this.isUploaded = true
                            this.$alert(res.data.data.length + ' record(s) uploaded', 'Uploaded Successfully', 'success')
                            // this.$vs.dialog({
                            // title: 'Success',
                            // text: this.tableData.length + ' record(s) uploaded',
                            // iconPack: 'feather',
                            // icon: 'icon-alert-circle',
                            // color: 'success'
                            // })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$alert(error.message, 'Upload Failed', 'error')
                    })
                  break;
              case "Deductions" :
                this.$store.dispatch('payroll/AddUploadedDeductions', data)
                .then((res) =>{
                            this.$vs.loading.close()
                            this.isUploaded = true
                            this.$alert(res.data.data.length + ' record(s) uploaded', 'Uploaded Successfully', 'success')
                            // this.$vs.dialog({
                            // title: 'Success',
                            // text: this.tableData.length + ' record(s) uploaded',
                            // iconPack: 'feather',
                            // icon: 'icon-alert-circle',
                            // color: 'success'
                            // })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$alert(error.message, 'Upload Failed', 'error')
                    })
                  break;
              case "Loans" :
                this.$store.dispatch('payroll/AddUploadedLoans', data)
                .then((res) =>{
                            this.$vs.loading.close()
                            this.isUploaded = true
                            this.$alert(res.data.data.length + ' record(s) uploaded', 'Uploaded Successfully', 'success')
                            // this.$vs.dialog({
                            // title: 'Success',
                            // text: this.tableData.length + ' record(s) uploaded',
                            // iconPack: 'feather',
                            // icon: 'icon-alert-circle',
                            // color: 'success'
                            // })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$alert(error.message, 'Upload Failed', 'error')
                    })
                  break;
          }


        },
        loadDataInTable ({ results, header, meta }) {
            this.header = header
            this.tableData = results
            this.sheetName = meta.sheetName
            // console.log('THIS.TABLEDATA')
            // console.log(this.tableData)
        },
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        ImportExcel,
    }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
// @import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
